import { render, staticRenderFns } from "./PositionAutocomplete.vue?vue&type=template&id=3ba8507f&scoped=true"
import script from "./PositionAutocomplete.vue?vue&type=script&lang=ts"
export * from "./PositionAutocomplete.vue?vue&type=script&lang=ts"
import style0 from "./PositionAutocomplete.vue?vue&type=style&index=0&id=3ba8507f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8507f",
  null
  
)

export default component.exports